import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { path: '/', label: t('nav.home') },
    { path: '/category/movies', label: t('nav.movies') },
    { path: '/category/tv', label: t('nav.tv') },
    { path: '/category/variety', label: t('nav.variety') },
    { path: '/category/anime', label: t('nav.anime') },
    { path: '/about', label: t('nav.about') },
  ];

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="text-xl font-heading font-bold text-background-50 mb-4">
              蜜桃影视
            </h3>
            <p className="text-sm leading-relaxed text-background-400">
              {t('footer.about')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              {t('footer.quick_links')}
            </h4>
            <div className="grid grid-cols-2 gap-2">
              {quickLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              {t('footer.contact')}
            </h4>
            <div className="space-y-2 text-sm text-background-400">
              <p>
                <i className="ri-mail-line mr-2"></i>
                {t('footer.email')}
              </p>
              <p>
                <i className="ri-phone-line mr-2"></i>
                {t('footer.phone')}
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-4 text-background-500">
            <a href="#" className="text-xs hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}